<template lang="html">
  <div class="page-admin show-cards-in-sequence-- show-cards-up--">
    <!--<navbar-component :profilePicture="avatarimage"/>-->

    <!--<dashboard-component>-->
      <div class="col-12">
        <div class="row">
          <card-component :col="{xs: 12, md: 6}">
            <h3>Cadastro do cliente</h3>
            <input-component placeholder="Nome" type='text' @updateValue="val => dados.buyer.name = val" :model="dados.buyer.name"/>
            <input-component placeholder="CPF" mask="###.###.###-##" type='text' @updateValue="val => dados.buyer.cpf = val" :model="dados.buyer.cpf"/>
            <input-component placeholder="Celular" mask="(##) #####-####" type='text' @updateValue="val => dados.buyer.phoneNumber = val" :model="dados.buyer.phoneNumber"/>
            <input-component placeholder="Data de Nascimento" mask="##/##/####" type='text' @updateValue="val => dados.buyer.birthDate = val" :model="dados.buyer.birthDate"/>
            <input-component placeholder="E-mail" type='text' @updateValue="val => dados.buyer.email = val" :model="dados.buyer.email"/>
            <h5>Endereço de entrega</h5>
            <input-component placeholder="CEP" mask="#####-###" type='text' @updateValue="onChangeCep" :model="dados.shipping.address.zip"/>
            <input-component placeholder="Rua" type='text' @updateValue="val => dados.shipping.address.street = val" :model="dados.shipping.address.street"/>
            <input-component placeholder="Número" type='text' @updateValue="val => dados.shipping.address.number = val" :model="dados.shipping.address.number"/>
            <input-component placeholder="Complemento" type='text' @updateValue="val => dados.shipping.address.complement = val" :model="dados.shipping.address.complement"/>
            <input-component placeholder="Bairro" type='text' @updateValue="val => dados.shipping.address.district = val" :model="dados.shipping.address.district"/>
            <input-component placeholder="Cidade" type='text' @updateValue="val => dados.shipping.address.city = val" :model="dados.shipping.address.city"/>
            <input-component placeholder="Estado" type='text' @updateValue="val => dados.shipping.address.state = val" :model="dados.shipping.address.state"/>
          </card-component>
          <card-component :col="{xs: 12, md: 6}">
            <h3>Detalhes do pedido</h3>
            <input-component placeholder="Número do pedido" type='text' @updateValue="val => dados.reference = val" :model="dados.reference"/>
            <input-component placeholder="Valor total do pedido" type='text' @updateValue="val => dados.payment.amount = val" :model="dados.payment.amount"/>
            <input-component placeholder="Valor do frete" type='text' @updateValue="val => dados.shipping.amount = val" :model="dados.shipping.amount"/>
            <button-component v-if="showConfirmButton" :nolink="true" @click.native="generateTransaction" class='btn-facebook' icon="micon-facebook" :disable="true">
              Confirmar Pedido
            </button-component>
            <lottie-component v-if="loadingTx"
              :options="loadingOptions"
              :height="200"
              :width="200" />
            <div v-if="transactionId">
              <h3>Enviar Proposta</h3>
              <div>Precisamos enviar um link para o cliente assinar o contrato digital e verificar a identidade</div>
              <button-component :nolink="true" @click.native="sendBySms" class='btn-facebook' :disable="true">
                Enviar por SMS
              </button-component>
              <lottie-component v-if="sendTx"
                                :options="sendOptions"
                                :height="200"
                                :width="200"
              />
              <button-component :nolink="true" @click.native="sendByEmail" class='btn-facebook' :disable="true">
                Enviar pelo e-mail
              </button-component>
            </div>
          </card-component>
        </div>
      </div>
    <!--</dashboard-component>-->

    <!--<background-component :bg="appbg"/>-->
  </div>
</template>
<script>
import jQuery from 'jquery/dist/jquery.js'
import Button from '../../partial/button/Button.vue'
import Card from '../../partial/card/Card.vue'
import Input from '../../partial/form/Input.vue'
import Navbar from '../../partial/navbar/Navbar.vue'
import Dashboard from '../../partial/dashboard/Dashboard.vue'
import Background from '../../partial/background/Background.vue'
import animationLoading from '../../../assets/animation/loading.json'
import animationSend from '../../../assets/animation/sendbutton.json'
import Lottie from 'vue-lottie'

export default {
  components: {
    'button-component': Button,
    'input-component': Input,
    'card-component': Card,
    'navbar-component': Navbar,
    'dashboard-component': Dashboard,
    'background-component': Background,
    'lottie-component': Lottie
  },
  data () {
    return {
      transactionId: null,
      loadingOptions: { animationData: animationLoading, loop: true },
      sendOptions: { animationData: animationSend, loop: false },
      loadingTx: false,
      sendTx: false,
      showConfirmButton: true,
      dados: {
        currency: 'BRL',
        cart: [
        ],
        reference: '',
        payment: {
          'amount': ''
        },
        buyer: {
          name: '',
          phoneNumber: '',
          cpf: '',
          email: '',
          birthDate: ''
        },
        shipping: {
          amount: '',
          address: {
            street: '',
            number: '',
            complement: '',
            district: '',
            zip: '',
            city: '',
            state: '',
            country: ''
          }
        }
      }
    }
  },
  mounted () {
    // this.$ga.page('/#/sample')
  },
  methods: {
    generateTransaction () {
      this.loadingTx = true
      this.showConfirmButton = false
      this.$http.post('api/transactions', this.dados)
        .then(function (res) {
          this.loadingTx = false
          console.log(res)
          this.transactionId = res.data.id
        })
        .catch(function (res) {
          this.showConfirmButton = true
          console.log('Error')
          console.log(res)
        })
    },
    sendBySms () {
      this.sendTx = true
      this.$http.post('api/sendLinkSms', {id: this.transactionId})
        .then(function (res) {
          console.log(res)
          this.sendTx = false
        })
        .catch(function (res) {
          console.log('Error')
          console.log(res)
        })
    },
    sendByEmail () {
      this.sendTx = true
      this.$http.post('api/sendLinkEmail', {id: this.transactionId})
        .then(function (res) {
          console.log(res)
          this.sendTx = false
        })
        .catch(function (res) {
          console.log('Error')
          console.log(res)
        })
    },
    onChangeCep (val) {
      this.dados.shipping.address.zip = val
      if (val.length === 8) {
        this.consultaCep()
      }
    },
    consultaCep () {
      var _this = this
      jQuery.get('https://viacep.com.br/ws/' + this.dados.shipping.address.zip + '/json/', function (data) {
        _this.dados.shipping.address.street = data.logradouro
        _this.dados.shipping.address.complement = data.complemento
        _this.dados.shipping.address.district = data.bairro
        _this.dados.shipping.address.city = data.localidade
        _this.dados.shipping.address.state = data.uf
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/transactions/CreateTransaction.vue